import { render } from "./AddNewTariff.vue?vue&type=template&id=1a22336c"
import script from "./AddNewTariff.vue?vue&type=script&lang=js"
export * from "./AddNewTariff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__